import Locale from "./Locale";

export default class Translator {
    private locales: Locale[] = [];
    private currentLocale: Locale | null = null;

    public addLocale(locale: Locale): void {
        if (!locale.region || !locale.content) {
            throw new Error(`Failed to parse locale data: ${locale}`);
        }
        const idx = this.locales.findIndex((x) => x.region === locale.region);
        if (idx > 0) {
            throw new Error(`Already added locale region: ${locale.region}`);
        }

        this.locales.push(locale);
    }

    public setLocale(region: string): void {
        const idx = this.locales.findIndex((x) => x.region === region);
        if (idx === -1) {
            // throw new Error(`Could not find locale ${region}`)
            this.currentLocale = this.getFallbackLocale();
        } else {
            this.currentLocale = this.locales[idx];
        }
    }

    public getFallbackLocale(): Locale | null {
        const localeIdx = this.locales.findIndex((x) => x.fallback);
        if (localeIdx > 0) {
            return this.locales[localeIdx];
        }

        return null;
    }

    public get(key: string): any {
        if (!key) {
            throw new Error("Cannot search locale resources with a missing key");
        }
        if (!this.currentLocale) {
            throw new Error("No locales have been loaded");
        }
        const contents = this.currentLocale.content;
        const split = key.split(".");
        let value: any; //eslint-disable-line
        // If the key is a root level search
        if (split.length === 0) {
            value = contents[key];
        }
        // If the key is a nested level search
        else {
            // Set the value to the contents of the locale
            value = contents;
            // Iterate through the splits
            for (let i = 0; i < split.length; ++i) {
                // And set the value to the nested object.
                // Example:
                // Key -> root.child
                value = value[split[i]];
                // If the value is undefined (we're searching with a node which doesn't exist)
                if (value === undefined) {
                    // Check if the current locale is the fallback locale and if it is, throw an error
                    // since we can't find the string in the fallback
                    if (this.currentLocale.fallback) {
                        throw new Error(`Failed to find value in relevant locale for key ${key}`);
                    }
                }
            }
        }

        // If the value's type isn't a string, then we can assume the user searched for a value
        // which returns a node with children
        // if (typeof value !== 'string') {
        //   throw new Error(`Value for locale key ${key} is not a string`)
        // }

        return value;
    }
}
